import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { RoleService } from 'ngx-core-services';
import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class OperatorGuard implements CanActivate {

  constructor(
    private readonly roleService: RoleService,
    private readonly router: Router,
  ) {}

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean | UrlTree> {
    const isOperator = await this.roleService.is_ZCS_Operator$.pipe(
      first(),
    ).toPromise();

    if (isOperator) {
      return true;
    }
    return this.router.createUrlTree(['/']);
  }
}
